import extenso from "extenso";
import { FuncaoService, Login, Relatorio, GlobalService, Empenho, OrgaoAssinaturaService, LicitacaoPipe, EmpenhoResto } from 'eddydata-lib';
import JsBarcode from 'jsbarcode';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { PageOrientation } from "pdfmake/interfaces";

export class EtiquetaEmpenhoResto {

  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;

  private log: Login;


  constructor(protected assinaturaService: OrgaoAssinaturaService) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
  }



  private retornaLayout() {
    return {
      linhas: {
        hLineWidth() {
          return 1;
        },
        vLineWidth() {
          return 1;
        },
        hLineColor() {
          return 'black';
        },
        paddingLeft() {
          return 3;
        },
        paddingRight() {
          return 3;
        },
      }
    };
  }


  public async imprimir(lista: EmpenhoResto[], login: Login, modelo: String) {
    this.log = login;
    if (modelo == 'mod1') {
        await Relatorio.imprimirPersonalizado('ETIQUETA DE EMPENHO', login.usuario.nome, login.usuario.sobrenome,
          login.orgao.nome, login.brasao, this.montarConteudo(lista, modelo), 'portrait', 'ETIQUETA EMPENHO', this.retornaLayout(), true, true,
          'pdf',null,[5,36.14625,5,36.14625],null,null,null,null,null,null,null,'LETTER')
    } else if (modelo == 'mod2') {
      await Relatorio.imprimirPersonalizado('ETIQUETA DE EMPENHO', login.usuario.nome, login.usuario.sobrenome,
        login.orgao.nome, login.brasao, this.montarConteudo(lista, modelo), 'portrait', 'ETIQUETA EMPENHO', this.retornaLayout(), true, true,
       'pdf', null, [5, 31, 12, 10], null, null, null, null, null, null, null, 'A4')
    } else {
      await Relatorio.imprimirPersonalizado('ETIQUETA DE EMPENHO', login.usuario.nome, login.usuario.sobrenome,
        login.orgao.nome, login.brasao, this.montarConteudo(lista, modelo), 'portrait', 'ETIQUETA EMPENHO', this.retornaLayout(), true, true,
       'pdf', null, [5, 31, 12, 10], null, null, null, null, null, null, null, 'A4')
    }
  }

  private montarConteudo(lista: EmpenhoResto[], modelo: String) {
    const conteudo = [];
    if (modelo == 'mod1') {
      for (let i = 0; i < lista.length; i = i + 2) {
        conteudo.push(this.dadosEmpenho(lista[i], lista[i + 1] ? lista[i + 1] : new EmpenhoResto()));

      }
    } else if (modelo == 'mod2') {
      for (let i = 0; i < lista.length; i = i+2) {
        conteudo.push(this.dadosEmpenhoModelo2(lista[i], lista[i + 1] ? lista[i + 1] : new EmpenhoResto()));

      }

    } else {
      for (let i = 0; i < lista.length; i = i + 2) {
        conteudo.push(this.dadosEmpenhoModelo3(lista[i], lista[i + 1] ? lista[i + 1] : new EmpenhoResto()));
      }
    }

    return conteudo;
  }

  private dadosEmpenhoModelo2(dados: EmpenhoResto,dados1: EmpenhoResto): {}[] {
    const body: {}[] = [];

    body.push([{
      columns: [
        {
          columns: [{
            columns: [{
              stack: [
                [{
                  text: `EMPENHO: ${dados.numero}`, alignment: 'left',
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  fontSize: 7,
                  bold: true
                }], [{
                  text: dados.favorecido.nome.slice(0, 35), alignment: 'left',
                  border: [false, true, false, false],
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  bold: true,
                  colspan: 2
                }],
                [{
                  text: `${dados.executora ? dados.executora + '-' : ''} ${dados.unidade_executora}`.slice(0, 35), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  fontSize: 7,
                }],
                [{
                  text: `${dados.recurso_variavel} - ${dados.recurso_variavel_nome}`.slice(0, 35), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  fontSize: 7,
                }],
                [{
                  text: `DATA EMPENHO: ${this.funcaoService.converteDataBR(dados.data_empenho)}`, alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, true, true, true],
                }],
                [{
                  text: `VL PRINCIPAL: ${this.funcaoService.convertToBrNumber(+dados.valor_empenho)}`, alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: `ESTORNO: ${this.funcaoService.convertToBrNumber(+dados['total_empenho_anulado'])}`, alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: 'COMPLEMENTO: 0,00', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: `TOTAL BRUTO: ${this.funcaoService.convertToBrNumber(+(+dados.valor_empenho + +dados['total_empenho_anulado']))}`, alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  bold: true,
                  border: [false, false, true, true],
                }],
                [{
                  text: 'OBSERVAÇÃO', alignment: 'center',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  width: '100%',
                  colspan: 2,
                  border: [false, false, false, false],
                }]], width: '60%'
            }, {
              stack: [[{
                text: `FICHA: ${dados['ficha_empenho']}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 7,
              }],
              [{ text: ' ', border: [false, true, false, false], }],
              [{ text: ' ' }],
              [{ text: ' ' }],
              [{
                text: `VENCIMENTO: ${this.funcaoService.converteDataBR(dados.data_vencimento)}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                bold: true,
                border: [false, true, true, true],
              }],
              [{
                text: `IRRF ${this.funcaoService.convertToBrNumber(+dados['valor_irrf'])}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: `INSS ${this.funcaoService.convertToBrNumber(+dados['valor_inss'])}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: `OUTROS ${this.funcaoService.convertToBrNumber(+dados['valor_ret_outros'])}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: `LIQ. RECEBER ${this.funcaoService.convertToBrNumber(+(+dados.valor_empenho + +dados['total_empenho_anulado']) - +(+dados['valor_iss'] + +dados['valor_ret_outros'] + +dados['valor_inss'] + +dados['valor_irrf']))}`, alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                bold: true,
                border: [false, false, false, true],
              }],
              [{ text: ' ', border: [false, false, false, false], alignment: 'right', }]], width: '40%'
            }]
          },
          ], width: '50%'
        }
        ,
        {
          columns: [{
            columns: [{
              stack: [
                [{
                  text: dados1.numero ? `EMPENHO: ${dados1.numero}` : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  fontSize: 7,
                  bold: true
                }], [{
                  text: dados1.numero ? dados1.favorecido.nome.slice(0, 35) : '', alignment: 'left',
                  border: [false, true, false, false],
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  bold: true,
                  colspan: 2
                }],
                [{
                  text: `${dados1.executora ? dados1.executora + '-' : ''} ${dados1.unidade_executora}`.slice(0, 35), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  fontSize: 7,
                }],
                [{
                  text: `${dados1.recurso_variavel} - ${dados1.recurso_variavel_nome}`.slice(0, 35), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  fontSize: 7,
                }],
                [{
                  text: dados1.numero ? `DATA EMPENHO: ${this.funcaoService.converteDataBR(dados1.data_empenho)}` : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, true, true, true],
                }],
                [{
                  text: dados1.numero ? `VL PRINCIPAL: ${this.funcaoService.convertToBrNumber(+dados1.valor_empenho)}` : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: dados1.numero ? `ESTORNO: ${this.funcaoService.convertToBrNumber(+dados1['total_empenho_anulado'])}` : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: dados1.numero ? 'COMPLEMENTO: 0,00' : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  border: [false, false, true, false],
                }],
                [{
                  text: dados1.numero ? `TOTAL BRUTO: ${this.funcaoService.convertToBrNumber(+(+dados1.valor_empenho + +dados1['total_empenho_anulado']))}` : '', alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  bold: true,
                  border: [false, false, true, true],
                }],
                [{
                  text: dados1.numero ? 'OBSERVAÇÃO' : '', alignment: 'center',
                  margin: [0, 0, 0, 0],
                  fontSize: 7,
                  width: '100%',
                  colspan: 2,
                  border: [false, false, false, false],
                }]], width: '60%'
            }, {
              stack: [[{
                text: dados1.numero ? `FICHA: ${dados1['ficha_empenho']}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 7,
              }],
              [{ text: ' ', border: [false, true, false, false], }],
              [{ text: ' ' }],
              [{ text: ' ' }],
              [{
                text: dados1.numero ? `VENCIMENTO: ${this.funcaoService.converteDataBR(dados1.data_vencimento)}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                bold: true,
                border: [false, true, true, true],
              }],
              [{
                text: dados1.numero ? `IRRF ${this.funcaoService.convertToBrNumber(+dados1['valor_irrf'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `INSS ${this.funcaoService.convertToBrNumber(+dados1['valor_inss'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `OUTROS ${this.funcaoService.convertToBrNumber(+dados1['valor_ret_outros'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `LIQ. RECEBER ${this.funcaoService.convertToBrNumber(+(+dados1.valor_empenho + +dados1['total_empenho_anulado']) - +(+dados1['valor_iss'] + +dados1['valor_ret_outros'] + +dados1['valor_inss'] + +dados1['valor_irrf']))}` : '', alignment: 'right',
                margin: [0, 0, 0, 0],
                fontSize: 7,
                bold: true,
                border: [false, false, false, true],
              }],
              [{ text: ' ', border: [false, false, false, false], alignment: 'right', }]], width: '40%'
            }]
          },
          ], width: '50%'
        }
      ], columnGap: 21, margin: [20, 4, 21, 63]
    }]);
  return [{
      layout: 'noBorders',
      table: {
        dontBreakRows: true,
        widths: ['*'],
        heights: 153.2,
        body: body,
      }
    }];


  }

  private dadosEmpenhoModelo3(dados: EmpenhoResto, dados1: EmpenhoResto): {}[] {
    const body: {}[] = [];

    body.push([{
      columns: [
        {
          columns: [{
            columns: [{
              stack: [
                [{
                  text: `NE Nº: ${dados.numero}|FH Nº:${dados['ficha_empenho']}`, alignment: 'left',
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                  bold: true
                }], [{
                  text: `DATA EMPENHO: ${this.funcaoService.converteDataBR(dados.data_empenho)}`, alignment: 'left',
                  margin: [0, 0, 0, 2],
                  fontSize: 7.5,
                  border: [false, true, true, true],
                }],
                [{
                  text: `O.F.: ${dados.compra?.numero}`.slice(0, 30), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                }],
                [{
                  text: dados.favorecido.nome.slice(0, 30), alignment: 'left',
                  border: [false, true, false, false],
                  margin: [0, 0, 0, 2],
                  fontSize: 7.5,
                  bold: true,
                  colspan: 2
                }],
                [{
                  text: `${dados.executora ? dados.executora + '-' : ''} ${dados.unidade_executora}`.slice(0, 35).slice(0, 30), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                }],
                [{
                  text: `${dados.recurso_variavel} - ${dados.recurso_variavel_nome}`.slice(0, 35), alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, true],
                  fontSize: 7.5,
                }],
                [{
                  text: ''
                }]], width: '60%'
            }, {
              stack: [[{
                text: `VENCIMENTO: ${this.funcaoService.converteDataBR(dados.data_vencimento)}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, true, true, true],
              }],
              [{
                text: `VL BRUTO: ${this.funcaoService.convertToBrNumber(+(+dados.valor_empenho + +dados['total_empenho_anulado']))}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, false, true, true],
              }],
              [{
                text: `( - )  IRRF ${this.funcaoService.convertToBrNumber(+dados['valor_irrf'])}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: `( - ) INSS ${this.funcaoService.convertToBrNumber(+dados['valor_inss'])}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: `( - )    ISS ${this.funcaoService.convertToBrNumber(+dados['valor_iss'])}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: `OUTROS ${this.funcaoService.convertToBrNumber(+dados['valor_ret_outros'])}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: `LIQ. RECEBER ${this.funcaoService.convertToBrNumber(+(+dados.valor_empenho + +dados['total_empenho_anulado']) - +(+dados['valor_iss'] + +dados['valor_ret_outros'] + +dados['valor_inss'] + +dados['valor_irrf']))}`, alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, false, false, true],
              }]], width: '40%'
            }]
          },
          ], width: '50%'
        }
        ,
        {
          columns: [{
            columns: [{
              stack: [
                [{
                  text:  dados1.numero ? `NE Nº: ${dados1.numero}|FH Nº:${dados1['ficha_empenho']}` : '', alignment: 'left',
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                  bold: true
                }], [{
                  text: dados1.numero ?  `DATA EMPENHO: ${this.funcaoService.converteDataBR(dados1.data_empenho)}` : '', alignment: 'left',
                  margin: [0, 0, 0, 2],
                  fontSize: 7.5,
                  border: [false, true, true, true],
                }],
                [{
                  text: dados1.numero ? `O.F.: ${dados1.compra?.numero}`.slice(0, 30) : '', alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                }],
                [{
                  text: dados1.numero ? dados1.favorecido.nome.slice(0, 30) : '', alignment: 'left',
                  border: [false, true, false, false],
                  margin: [0, 0, 0, 2],
                  fontSize: 7.5,
                  bold: true,
                  colspan: 2
                }],
                [{
                  text: dados1.numero ? `${dados1.executora ? dados1.executora + '-' : ''} ${dados1.unidade_executora}`.slice(0, 35) : '', alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, false],
                  fontSize: 7.5,
                }],
                [{
                  text: dados1.numero ? `${dados1.recurso_variavel} - ${dados1.recurso_variavel_nome}`.slice(0, 35) : '', alignment: 'left', colSpan: 2,
                  margin: [0, 0, 0, 2],
                  border: [false, false, false, true],
                  fontSize: 7.5,
                }],     
                [{
                  text: ''
                }]], width: '60%'
            }, {
              stack: [[{
                text: dados1.numero ? `VENCIMENTO: ${this.funcaoService.converteDataBR(dados1.data_vencimento)}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, true, true, true],
              }],
              [{
                text: dados1.numero ? `VL BRUTO: ${this.funcaoService.convertToBrNumber(+(+dados1.valor_empenho + +dados1['total_empenho_anulado']))}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, false, true, true],
              }],
              [{
                text: dados1.numero ? `( - )  IRRF ${this.funcaoService.convertToBrNumber(+dados1['valor_irrf'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `( - ) INSS ${this.funcaoService.convertToBrNumber(+dados1['valor_inss'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `( - )    ISS ${this.funcaoService.convertToBrNumber(+dados1['valor_iss'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `OUTROS ${this.funcaoService.convertToBrNumber(+dados1['valor_ret_outros'])}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                border: [false, false, false, false],
              }],
              [{
                text: dados1.numero ? `LIQ. RECEBER ${this.funcaoService.convertToBrNumber(+(+dados1.valor_empenho + +dados1['total_empenho_anulado']) - +(+dados1['valor_iss'] + +dados1['valor_ret_outros'] + +dados1['valor_inss'] + +dados1['valor_irrf']))}` : '', alignment: 'right',
                margin: [0, 0, 0, 2],
                fontSize: 7.5,
                bold: true,
                border: [false, false, false, true],
              }]], width: '40%'
            }]
          },
          ], width: '50%'
        }
      ], columnGap: 21, margin: [20, 4, 21, 63]
    }]);
    return [{
      layout: 'noBorders',
      table: {
        dontBreakRows: true,
        widths: ['*'],
        heights: 153.2,
        body: body,
      }
    }];
  }



  private dadosEmpenho(dados: EmpenhoResto, dados1: EmpenhoResto): {}[] {
    const conteudo = [];
    conteudo.push([{
      columns: [
        {
          columns: [
            {
              stack: [
                [{ text: `EMPENHO Nº: ${this.funcaoService.strZero(dados.numero, 4)}`, alignment: 'left', bold: true }],
                `${dados.favorecido.nome}`,
                `${dados.executora ? dados.executora : ''} - ${dados.unidade_executora}`,
                `VALOR: ${this.funcaoService.convertToBrNumber(+dados.valor_empenho)}`,
              ]
              , width: '70%'
            }, {
              stack: [
                [{ text: `DATA: ${this.funcaoService.converteDataBR(dados.data_empenho)}`, alignment: 'right', bold: true }],
                [{ text: ' ', alignment: 'right' }],
                [{ text: ' ', alignment: 'right' }],
                [{ text: `FICHA Nº: ${dados['ficha_empenho']}`, alignment: 'right' }],
              ]
              , width: '30%'
            }
          ], width: '50%'
        }

        , {

          columns: [
            {
              stack: [
                [{ text: dados1.numero ? `EMPENHO Nº: ${this.funcaoService.strZero(dados1.numero, 4)}` : '', alignment: 'left', bold: true }],
                dados1.numero ? `${dados1.favorecido.nome}` : '',
                dados1.numero ?  `${dados1.executora ? dados1.executora : ''} - ${dados1.unidade_executora}` : '',
                dados1.numero ? `VALOR: ${this.funcaoService.convertToBrNumber(+dados1.valor_empenho)}` : '',
              ]
              , width: '70%'
            }, {
              stack: [
                [{ text: dados1.numero ? `DATA: ${this.funcaoService.converteDataBR(dados1.data_empenho)}` : '', alignment: 'right', bold: true }],
                [{ text: ' ', alignment: 'right' }],
                [{ text: ' ', alignment: 'right' }],
                [{ text: dados1.numero ? `FICHA Nº: ${dados1['ficha_empenho']}` : '', alignment: 'right' }],
              ]
              , width: '30%',
            },
          ], width: '50%'
        }

      ], columnGap: 21, margin: [8, 15, 8, 0]
    }
    ],);

    return [{
      layout: 'noBorders',
      dontBreakRows: true,
      table: {
        dontBreakRows: true,
        widths: ['*'],
        heights: 67.9705,
        body: conteudo,
      }
    }]
  }


}